module.exports = __webpack_public_path__ + "static/media/detail-active.8690615a.svg";